var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [
            { icon: "sitemap", path: "/" + _vm.section, page: "ORGANIGRAMA" },
            {
              icon: "circle",
              page: _vm.is_new ? "Nuevo puesto" : "Editar puesto",
            },
          ],
        },
      }),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-tabs",
            {
              staticClass: "custom-tabs mb-4",
              attrs: {
                "background-color": "#fff",
                "slider-color": "transparent",
              },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                "v-tab",
                {
                  staticClass: "custom-tab",
                  class: { "active-tab": _vm.tab === 0 },
                },
                [_vm._v("Puesto")]
              ),
              !_vm.is_new
                ? _c(
                    "v-tab",
                    {
                      staticClass: "custom-tab",
                      class: { "active-tab": _vm.tab === 1 },
                    },
                    [
                      _vm._v(
                        "Dependientes (" +
                          _vm._s(_vm.item.children.length) +
                          ")"
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              staticStyle: { background: "transparent" },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                "v-tab-item",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", lg: "3" } },
                        [
                          _vm.loading_item
                            ? _c("CardSkeletonList", { attrs: { count: 1 } })
                            : _c("CardPreview", {
                                attrs: {
                                  item: _vm.item,
                                  parent: _vm.parent_node,
                                  children: _vm.item.children,
                                },
                              }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", lg: "9" } },
                        [
                          _vm.loading_item
                            ? _c("CardSkeletonList", { attrs: { count: 3 } })
                            : [
                                _c("NodeForm", {
                                  ref: "NodeForm",
                                  attrs: {
                                    item: _vm.item,
                                    nodes: _vm.nodes,
                                    node_types: _vm.node_types,
                                    sucursales: _vm.sucursales,
                                    worksectors: _vm.worksectors,
                                    legajos: _vm.legajos,
                                    loading_legajos: _vm.loading_legajos,
                                    disabled: _vm.read_only,
                                  },
                                }),
                                !_vm.is_new
                                  ? _c("CardDependents", {
                                      attrs: {
                                        parent_id: _vm.item.id,
                                        children: _vm.item.children,
                                        create_access: _vm.create_access,
                                        update_access: _vm.update_access,
                                        delete_access: _vm.delete_access,
                                      },
                                      on: {
                                        addChild: _vm.addChild,
                                        editChild: _vm.goToNode,
                                        assignResponsible:
                                          _vm.assignResponsible,
                                        deleteChild: (child) =>
                                          _vm.confirmDelete(child),
                                        reordered: _vm.loadItem,
                                      },
                                    })
                                  : _vm._e(),
                                _c("v-card", { staticClass: "pa-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-wrap" },
                                    [
                                      !_vm.is_new && _vm.delete_access
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                outlined: "",
                                                color: "error",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.confirmDelete(
                                                    _vm.item
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Eliminar puesto")]
                                          )
                                        : _vm._e(),
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mr-3",
                                          attrs: {
                                            outlined: "",
                                            color: "primary",
                                          },
                                          on: { click: _vm.back },
                                        },
                                        [_vm._v("Cancelar")]
                                      ),
                                      !_vm.read_only
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading: _vm.loading_save,
                                              },
                                              on: { click: _vm.save },
                                            },
                                            [_vm._v("Guardar")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.is_new
                ? _c(
                    "v-tab-item",
                    [
                      _c("CardDependents", {
                        attrs: {
                          parent_id: _vm.item.id,
                          children: _vm.item.children,
                          create_access: _vm.create_access,
                          update_access: _vm.update_access,
                          delete_access: _vm.delete_access,
                        },
                        on: {
                          addChild: _vm.addChild,
                          editChild: _vm.goToNode,
                          assignResponsible: _vm.assignResponsible,
                          deleteChild: (child) => _vm.confirmDelete(child),
                          reordered: _vm.loadItem,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.update_access
            ? _c("ModalAssignResponsible", {
                attrs: { dialog: _vm.dialog_assign, node: _vm.node_assign },
                on: {
                  updateDialog: (value) => (_vm.dialog_assign = value),
                  assigned: _vm.loadItem,
                },
              })
            : _vm._e(),
          _c("DialogDelete", {
            attrs: {
              dialog_delete: _vm.dialog_delete,
              subtext: _vm.DELETE_SUBTEXT,
            },
            on: {
              updateDialogDelete: _vm.updateDialogDelete,
              deleteItemConfirm: _vm.deleteItemConfirm,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }